import { create } from 'zustand';
import { isCaptchaRequired } from '../../../core/config/captcha';

// Chỉ giữ state UI phải sống qua lúc rời trang. Dữ liệu API do TanStack Query cache (xem data/hooks.js);
// serial đang tra nằm trên URL (?serial=) để share link/F5 vẫn đúng, không để ở đây.
export const useWarrantyLookupStore = create((set) => ({
  // Đã xác thực reCAPTCHA ít nhất 1 lần trong phiên chưa — chỉ bắt xác thực lại lần đầu.
  // Môi trường không bắt tick captcha thì coi như đã xác thực sẵn.
  hasVerifiedCaptcha: !isCaptchaRequired,
  setHasVerifiedCaptcha: (hasVerifiedCaptcha) => set({ hasVerifiedCaptcha }),
}));
